import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { SmsTextareaComponent } from '@modules/sms/components/sms-textarea/sms-textarea.component';
import { requiredNonEmpty } from '@utils/validators';
import { SmsService } from '@services/sms.service';
import { SmsTemplate } from '@models/sms/templates';
import { AtlasToastService } from '@services/atlas-toast.service';

@Component({
  selector: 'wsb-create-sms-template-modal',
  templateUrl: './sms-template-create-edit-modal.component.html',
  styleUrls: ['./sms-template-create-edit-modal.component.scss'],
  standalone: false
})
export class SmsTemplateCreateEditModalComponent implements OnInit {
  @ViewChild('smsEditorView', { static: true }) smsEditorView: SmsTextareaComponent;

  @Input() smsTemplate?: SmsTemplate;
  @Input() isSendSaveAsTemplate = false;

  // for smsadv
  isSmsAdvTemplate = false;

  templateNameControl = this.fb.control('', [Validators.required, requiredNonEmpty(), Validators.maxLength(64)]);

  form = this.fb.group({
    name: this.templateNameControl
  });

  constructor(
    public activeModal: NgbActiveModal,
    private fb: UntypedFormBuilder,
    private smsService: SmsService,
    private toastService: AtlasToastService
  ) {}

  ngOnInit(): void {
    this.form.addControl('textarea', this.smsEditorView.formGroup);

    if (this.smsTemplate) {
      this.templateNameControl.setValue(this.smsTemplate.name);
      this.smsEditorView.setValue(this.smsTemplate.text, this.smsTemplate.encoding);
    }
    if (this.isSmsAdvTemplate) {
      this.smsEditorView.initTextAreaForSmsAdv();
    }
  }

  public save(): void {
    if (this.form.invalid) {
      this.highlightFormErrors();
      return;
    }

    if (!this.form.dirty && this.smsTemplate) {
      this.activeModal.close();
      return;
    }

    let smsTemplate = new SmsTemplate();
    if (this.smsTemplate) {
      smsTemplate = Object.assign(smsTemplate, this.smsTemplate);
    }

    smsTemplate.name = this.templateNameControl.value;
    smsTemplate.text = this.smsEditorView.textControl.value;
    smsTemplate.encoding = this.smsEditorView.encodingControl.value;

    if (this.isSendSaveAsTemplate) {
      this.smsService.createSmsTemplate(smsTemplate).subscribe(
        () => {
          this.activeModal.close();
          this.toastService.success('common_success', '');
        },
        () => {
          this.toastService.error('sms_template_save_error', '');
        }
      );
    } else {
      const saveFun = this.smsTemplate
        ? this.smsService.updateSmsTemplate(this.smsTemplate, smsTemplate)
        : this.smsService.createSmsTemplate(smsTemplate);
      saveFun.subscribe(
        () => {
          this.activeModal.close();
          this.toastService.success('common_success', '');
        },
        () => {
          this.toastService.error('sms_template_save_error', '');
        }
      );
    }
  }

  private highlightFormErrors(): void {
    this.form.controls.name.markAsDirty();
    this.form.controls.name.updateValueAndValidity();
    this.smsEditorView.textControl.markAsDirty();
    this.smsEditorView.textControl.updateValueAndValidity();
  }
}
